import { some } from 'lodash';

export interface UserAccessRulable {
  usersWithAccess: string[];
}

export function isAccessibleForUser(ar: UserAccessRulable, userId: string): boolean {
  return some(ar.usersWithAccess, (id) => id == userId);
}
